import React, { useEffect, useState } from "react";
import "./Poupup.css";
import { getSiteSettings } from "../api/siteSettingsApi";

export default function PopupOnce() {
  const [showPopup, setShowPopup] = useState(false);
  const [settings, setSettings] = useState({ enabled: true, title: '', content: '' });

  useEffect(() => {
    getSiteSettings().then(s => {
      const popup = s.popup || { enabled: true, title: '', content: '' };
      setSettings(popup);
      if (!popup.enabled || !popup.title) return;
      const lastShown = localStorage.getItem("welcomePopupDate");
      const today = new Date().toDateString();
      if (lastShown === today) return;
      setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem("welcomePopupDate", today);
      }, 2500);
    });
  }, []);

  if (!showPopup) return null;

  return (
    <div className="popup-overlay" onClick={() => setShowPopup(false)}>
      <div className="popup-box" onClick={e => e.stopPropagation()}>
        <div className="popup-header">
          <button className="close-btn" onClick={() => setShowPopup(false)}>✖</button>
          <h2 className="popup-title">{settings.title}</h2>
        </div>
        <div className="popup-body">
          <p className="popup-text">{settings.content}</p>
        </div>
      </div>
    </div>
  );
}
